import './polyfills';
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { appConfig } from './app/app.config';
import { AppConfig, APP_CONFIG } from './app.config';
import { OKTA_CONFIG } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { provideLottieOptions } from 'ngx-lottie';

fetch('/assets/config.json')
    .then((response) => response.json())
    .then((config: AppConfig) => {
        if (environment.production) {
            enableProdMode();
        }

        const oktaAuth = new OktaAuth({
            issuer: config.okta.issuer,
            clientId: config.okta.clientId,
            redirectUri: config.okta.redirectUri,
            scopes: config.okta.scopes,
            pkce: config.okta.pkce,
        });

        bootstrapApplication(AppComponent, {
            providers: [
                provideZoneChangeDetection(),
                { provide: APP_CONFIG, useValue: config },
                { provide: OKTA_CONFIG, useValue: { oktaAuth } },
                provideLottieOptions({
                    player: () => import('lottie-web'),
                }),
                ...appConfig.providers,
            ],
        }).catch((err) => console.error(err));
    });
